import React, { useState, useEffect } from "react";
import { format, parse } from "date-fns";
import { datePickerIcon } from "../../../../assetData/icons";
import { cn } from "../../../../utils/twMerge";

import "./styles.css";

const CustomDate = ({
  initialValue,
  className,
  setHandleSetValue,
  ...props
}) => {
  const [inputValue, setInputValue] = useState(() => initialValue ?? null);

  const formatDate = (rawDate) => {
    if (!rawDate) return;
    const parsedDate = parse(rawDate, "yyyy-MM-dd", new Date());
    const formattedDate = format(parsedDate, "dd MMM yyyy");
    return formattedDate;
  };

  const hndleOnChange = (e) => {
    const date = e.target.value;
    setInputValue(formatDate(date));
    setHandleSetValue((prev) => ({
      ...prev,
      ["bookclose_recorddate"]: date,
    }));
  };

  useEffect(() => {
    // console.log(initialValue);
    if (!initialValue) setInputValue(null);
    setInputValue(() => {
      const formattedDate = formatDate(initialValue);
      return formattedDate;
    });
  }, [initialValue]);

  return (
    <div
      className={cn(
        "relative flex w-full justify-between gap-2 rounded-[4px] bg-gray-100 px-3 py-3",
        className && className,
      )}
      style={{ width: "100%", height: "100%" }}
    >
      <div className="text-sm">{inputValue ?? "dd mmm yyyy"}</div>
      <img src={datePickerIcon} className="w-5" />
      <input
        {...props}
        type="date"
        onChange={hndleOnChange}
        className="cus-date-input w-full"
      />
    </div>
  );
};

export default CustomDate;
